<template>
  <div class="h-auto md:h-screen flex flex-col md:flex-row">
    <div
      class="bg-yellow-500 h-20 md:h-screen flex flex-col justify-center w-full md:w-1/2"
    >
      <h3 class="font-bold text-4xl left-header">About me</h3>
      <navigation :primary="'dark'" class="md:mt-64" />
    </div>
    <div class="w-full md:w-1/2 p-2 text-left">
      <div class="mt-10 sm:mt-15 ml-5 sm:ml-10">
        <div class="text-lg md:text-xl font-bold">
          Hi,
          <span class="text-base md:text-lg font-normal"
            >I believe you already know my name now...so lets skip the name. I
            am a</span
          >
        </div>
        <div class="mt-10">
          <div class="text-base md:text-lg font-bold mt-2">
            P
            <span class="font-normal"
              >assionate web developer, who is always</span
            >
          </div>
          <div class="text-base md:text-lg font-bold mt-1">
            E
            <span class="font-normal"
              >ager to learn new technologies and gain knowledge based on daily
              experiences.</span
            >
          </div>
          <div class="text-base md:text-lg font-bold mt-1">
            T
            <span class="font-normal"
              >alented musician, there's a link to my instagram handle. Do take
              some time to listen to some of my covers.</span
            >
          </div>
          <div class="text-base md:text-lg font-bold mt-1">
            E
            <span class="font-normal"
              >quipped with problem solving skills.</span
            >
          </div>
          <div class="text-base md:text-lg font-bold mt-1">
            R
            <span class="font-normal"
              >egularly trying to update myself with the new web trends and
              designs.</span
            >
          </div>
        </div>
      </div>
      <div class="p-1 sm:p-2 m-1 sm:m-5 mt-10 sm:mt-8 md:mt-14 lg:mt-16">
        <div class="flex border-b">
          <div :class="currentTab == 'FrontEnd' ? '-mb-px' : ''" class="mr-1">
            <span
              @click="changeTab('FrontEnd')"
              class="cursor-pointer bg-white inline-block py-2 md:px-4 px-2 text-gray-500 hover:text-gray-800 font-semibold"
              :class="currentTab == 'FrontEnd' ? activeClass : ''"
              >Frontend</span
            >
          </div>
          <div class="mr-1" :class="currentTab == 'BackEnd' ? '-mb-px' : ''">
            <span
              @click="changeTab('BackEnd')"
              :class="currentTab == 'BackEnd' ? activeClass : ''"
              class="cursor-pointer bg-white inline-block py-2 md:px-4 px-2 text-gray-500 hover:text-gray-800 font-semibold"
              >Backend</span
            >
          </div>
          <div class="mr-1" :class="currentTab == 'Database' ? '-mb-px' : ''">
            <span
              @click="changeTab('Database')"
              :class="currentTab == 'Database' ? activeClass : ''"
              class="cursor-pointer bg-white inline-block py-2 md:px-4 px-2 text-gray-500 hover:text-gray-800 font-semibold"
              >Database</span
            >
          </div>
          <div class="mr-1" :class="currentTab == 'ServerConf' ? '-mb-px' : ''">
            <span
              @click="changeTab('ServerConf')"
              :class="currentTab == 'ServerConf' ? activeClass : ''"
              class="cursor-pointer bg-white inline-block py-2 md:px-4 px-2 text-gray-500 hover:text-gray-800 font-semibold"
              >Server</span
            >
          </div>
          <div
            class="text-right w-full text-xs py-2 md:px-4 px-2 text-gray-500 font-semibold hidden xl:block"
          >
            *Hover over the icons to see more info.
          </div>
        </div>
        <div class="p-1 sm:p-5 w-100 text-left">
          <component :is="currentTab"></component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FrontEnd from "./technologies/FrontEnd";
import BackEnd from "./technologies/BackEnd";
import ServerConf from "./technologies/ServerConf";
import Database from "./technologies/Database";
import Navigation from "./Navigation";

export default {
  components: {
    FrontEnd,
    BackEnd,
    ServerConf,
    Database,
    Navigation,
  },
  data() {
    return {
      currentTab: "FrontEnd",
      activeClass: "border-l border-t border-r rounded-t text-gray-700",
    };
  },
  methods: {
    changeTab(name) {
      this.currentTab = name;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Piedra&display=swap");
.left-header {
  font-family: "Piedra", cursive;
  letter-spacing: 5px;
  word-spacing: 10px;
}
</style>
